import z from "zod";
import { BASE_CHAIN_ID, BASE_COMBO_MACHINE_ADDRESS, BASE_FLEX_COMBO_MACHINE_ADDRESS } from "./chain-constants";
import { BetTypeSchema } from "./plain-schemas";

export function getBetTypeByChainInfoOrFail(
	chain_id: number,
	contract_address: string,
) {

	const bet_type_address_mapping: Record<number, Record<string, z.infer<typeof BetTypeSchema>>> = {
		[BASE_CHAIN_ID]: {
			[BASE_COMBO_MACHINE_ADDRESS]: "powerplay",
			[BASE_FLEX_COMBO_MACHINE_ADDRESS]: "flexplay",
		},
	};

	const bet_type = bet_type_address_mapping[chain_id]?.[contract_address];

	if(!bet_type) {
		throw new Error(`Unsupported chain_id ${chain_id} and contract_address ${contract_address} combination`);
	}

	return bet_type;
}
